export default __webpack_public_path__ + "static/media/gnl6.7baaf35c.webp";